<div class="wrapper" #wrapper>
  <div class="wrapper__header">
    <h2 class="wrapper__title beta">{{ 'documents.myContacts' | translate }}</h2>
  </div>

  <app-multi-selection-toolbar
    (onClose)="closeSelection()"
    [isOpen]="contacts && (contacts | filterBy: { _isSelected: true }).length > 0"
    [label]="
      'documents.' + ((contacts | filterBy: { _isSelected: true }).length === 1 ? 'selectedContact' : 'selectedContacts') | translate: { contact: (contacts | filterBy: { _isSelected: true }).length }
    "
  >
    <div class="selection-toolbar__divider"></div>
    <button type="button" class="btn-M btn-text btn-text-danger icon-start" (click)="deleteSelectedContacts()">
      <i class="far fa-trash"></i>
      {{ 'button.exclude' | translate }}
    </button>
  </app-multi-selection-toolbar>

  <div class="container">
    <div class="container__inside" #container__inside>
      <table class="table">
        <thead>
          <div class="columns-dropdown" display="dynamic" placement="bottom-right" appDropdown>
            <label appDropdownToggle><i class="fal fa-columns"></i></label>
            <div appDropdownMenu>
              <button type="button" class="dropdown__item-checkbox">
                <label>
                  <app-checkbox (change)="changeColumn('c1')" [value]="columnControl.columns.c1"></app-checkbox>&nbsp;
                  {{ 'profile.name' | translate }}
                </label>
              </button>
              <button type="button" class="dropdown__item-checkbox">
                <label>
                  <app-checkbox (change)="changeColumn('c2')" [value]="columnControl.columns.c2"></app-checkbox>&nbsp; {{ 'profile.email' | translate }}/{{ 'profile.phone' | translate }}
                </label>
              </button>
              <button type="button" class="dropdown__item-checkbox">
                <label>
                  <app-checkbox (change)="changeColumn('c3')" [value]="columnControl.columns.c3"></app-checkbox>&nbsp;
                  {{ 'profile.birth' | translate }}
                </label>
              </button>
              <button type="button" class="dropdown__item-checkbox">
                <label>
                  <app-checkbox (change)="changeColumn('c4')" [value]="columnControl.columns.c4"></app-checkbox>&nbsp;
                  {{ 'profile.cpf' | translate }}
                </label>
              </button>
            </div>
          </div>
          <tr class="table__headerRow">
            <th class="c0">
              <div class="contactMainCheckboxColumn">
                <input
                  type="checkbox"
                  class="checkbox__field"
                  [id]="'inpt-validationSmsId-'"
                  [indeterminate]="indetermineMainCheckbox()"
                  [checked]="isMainCheckboxChecked"
                  (change)="onChangeMainCheckbox(!isMainCheckboxChecked)"
                  #mainCheckbox
                />
                <label class="checkbox__label" [for]="'inpt-validationSmsId-'"></label>
                <div class="contacts__title dot" style="z-index: -1000">.</div>
              </div>
            </th>
            <th resizable class="c1" *ngIf="columnControl.columns.c1" #c1>
              <div class="contacts__header">
                <div class="contacts__title">{{ 'profile.name' | translate }}</div>
                <input class="contacts__search" placeholder="{{ 'shared.searchEllips' | translate }}" #inputName [(ngModel)]="searchNameResult" (keyup)="searchContacts(inputName.value)" type="text" />
              </div>
            </th>
            <th resizable class="c2" *ngIf="columnControl.columns.c2" #c2>
              <div class="contacts__header">
                <div class="contacts__title">{{ 'profile.email' | translate }}/{{ 'profile.phone' | translate }}</div>
                <input
                  class="contacts__search"
                  placeholder="{{ 'shared.searchEllips' | translate }}"
                  #inputEmail
                  [(ngModel)]="searchEmailResult"
                  (keyup)="searchContacts(inputEmail.value)"
                  type="text"
                />
              </div>
            </th>
            <th resizable class="c3" *ngIf="columnControl.columns.c3" #c3>
              <div class="contacts__header">
                <div class="contacts__title">{{ 'profile.birthDate' | translate }}</div>
                <input class="contacts__search" disabled placeholder="" type="text" />
              </div>
            </th>
            <th resizable class="c4" *ngIf="columnControl.columns.c4" #c4>
              <div class="contacts__header">
                <div class="contacts__title">{{ 'profile.cpf' | translate }}</div>
                <input class="contacts__search" disabled placeholder="" type="text" />
              </div>
            </th>
            <th resizable class="c5" *ngIf="columnControl.columns.c5" #c5>
              <div class="contacts__header">
                <div class="contacts__title">{{ 'profile.createdId' | translate }}</div>
                <input class="contacts__search" disabled type="text" placeholder="" />
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let contact of contacts; let i = index" class="table_BodyRow">
            <td class="table_BodyRow_DataCell">
              <div class="contacts__checkbox">
                <input type="checkbox" class="checkbox__field" [(ngModel)]="contact._isSelected" [id]="'inpt-contactId-' + i" (change)="onChangeCheckbox()" />
                <label class="checkbox__label" [for]="'inpt-contactId-' + i"></label>
              </div>
            </td>
            <td class="table_BodyRow_DataCell" *ngIf="columnControl.columns.c1">
              <div class="contacts__data">
                <p class="contacts__data__user-name">{{ contact.name }}</p>
                <p class="contacts__data__company" *ngIf="contact?.company"><i class="far fa-building"></i>{{ contact.company }}</p>
              </div>
            </td>
            <td class="table_BodyRow_DataCell" *ngIf="columnControl.columns.c2">
              <div class="contacts__data">
                @if (contact.email) {
                  <p class="contacts__data__email"><i class="far fa-envelope"></i>{{ contact.email }}</p>
                }
                @if (contact.phone) {
                  <p class="contacts__data__phone"><i class="far fa-phone"></i>{{ contact.phone }}</p>
                }
              </div>
            </td>
            <td class="table_BodyRow_DataCell" *ngIf="columnControl.columns.c3">
              <div class="contacts__data">
                <p class="contacts__data__birthday">{{ contact.born }}</p>
              </div>
            </td>
            <td class="table_BodyRow_DataCell" *ngIf="columnControl.columns.c4">
              <div class="contacts__data">
                <p class="contacts__data__cpf">{{ contact.cpf | cpfCnpj }}</p>
              </div>
            </td>
            <td class="table_BodyRow_DataCell" *ngIf="columnControl.columns.c5">
              <div class="contacts__created">
                <p class="contacts__data__created-at">{{ contact.add }}</p>
                <div appDropdown placement="bottom-right">
                  <button type="button" class="dropdown__toggle-control dropdown__toggle-control--icon-only" appDropdownToggle>
                    <i class="far fa-ellipsis-v"></i>
                  </button>

                  <div appDropdownMenu>
                    <button type="button" class="dropdown__item--danger" appDropdownItem (click)="deleteSelectedContacts(contact.id)">
                      <i class="fa-regular fa-trash"></i>
                      {{ 'button.exclude' | translate }}
                    </button>
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="noContact" *ngIf="contacts.length === 0">
        <div class="noContact__title">{{ 'settings.nothingHere' | translate }}</div>
        <div class="noContact__text">
          <span>{{ 'documents.noContactsFound' | translate }} </span>
        </div>
      </div>
    </div>
    <div class="wrapper__more" *ngIf="showPagination">
      <button type="button" class="wrapper__more-button" (click)="loadMoreContacts()">{{ 'documents.loadMoreContacts' | translate }}</button>
    </div>
  </div>
</div>
